export default "__VITE_ASSET__DxyuyyKT__"